import { fetchUtils } from 'react-admin';
import { clearAuthStorage } from '../auth/authStorage';
import { isTokenExpired } from './jwtUtils';

const httpClient = (url: string, options: fetchUtils.Options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  } else if (!(options.headers instanceof Headers)) {
    options.headers = new Headers(options.headers);
  }

  const token = localStorage.getItem('user_authToken');
  if (token && !isTokenExpired(token)) {
    options.headers.set('Authorization', `Bearer ${token}`);
  } else if (token && isTokenExpired(token)) {
    clearAuthStorage();
  }

  return fetchUtils.fetchJson(url, options).catch((error) => {
    if (error.status === 401) {
      clearAuthStorage();
    }
    throw error;
  });
};

export default httpClient;
